const TenantMembershipPermissionsEnum = Object.freeze({
	ETI_ADMIN: 'EtiAdmin',
	ETI_STAFF: 'EtiStaff',
	TO_ADMIN: 'ToAdmin',
	REVENUE_ADMIN: 'RevenueAdmin',
	REVENUE_STAFF: 'RevenueStaff',
	COLLECTIONS_ADMIN: 'CollectionsAdmin',
	COLLECTIONS_VAULT_TECHNICIAN: 'CollectionsVaultTechnician',
	COLLECTIONS_FIELD_COLLECTOR: 'CollectionsFieldCollector',
	COLLECTIONS_PROJECT_TECHNICIAN: 'CollectionsProjectTechnician',
});

export default TenantMembershipPermissionsEnum;
